import React, { InputHTMLAttributes, useEffect, useState } from 'react';
import Editor from 'react-simple-code-editor';


interface IEquationEditor extends InputHTMLAttributes<HTMLInputElement>
{
    name:string;
    placeholder?: string| 'Selecione...';
    defaultValue?: string;
    suggestionTitle?: string;
    options: Array<{ value: string; text: string; }>;
    onChange?: (selectedOptions: any) => void;
}

export const EquationEditor: React.FC<IEquationEditor> = ({ name = '', ...props }) => {
    
    const [value, setValue] = useState('');
    const [suggestions, setSuggestions] = useState<Array<string>>([]);
    

    useEffect(() => {
      if (props.defaultValue) 
      {
        setValue(props.defaultValue)
      }

    }, [props.defaultValue])

    // Atualiza o valor do editor e filtra sugestões
    const handleValueChange = (code: string) => {
      setValue(code);
      handleSuggestions(code);
    };
  
    // Filtra lista de sensores com base no último token
    const handleSuggestions = (code: any) => {
      const tokens = code.split(/\s+/);
      const lastToken = tokens[tokens.length - 1];
      if (!lastToken) {
        setSuggestions([]);
        return;
      }
      const matched = props.options.filter((option) =>
        option.text.toLowerCase().startsWith(lastToken.toLowerCase())
      );
      setSuggestions(matched.map(p => p.text));
    };


    const handleOnFocus = () => { 
      setSuggestions([]);
      setSuggestions(props.options.map(p => p.text));
    }


    // Captura a tecla Tab para substituir o último token pela sugestão
    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>|React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (e.key === 'Tab' && suggestions.length > 0) {
        e.preventDefault();
        const tokens = value.split(/\s+/);
        tokens[tokens.length - 1] = suggestions[0]; // pega a primeira sugestão
        const newValue = tokens.join(' ');
        setValue(newValue);
        if (props.onChange) props.onChange(newValue);
        setSuggestions([]);
      }
    };

    function highlight(code:string) {
      const regex = new RegExp(`\\b(${props.options.map(p => p.text).join('|')})\\b`, 'gi');
      return code.replace(regex, (match) => {
        return `<span style="background: #0c5c75; color:white; border-radius: 4px;">${match}</span>`;
      });
    }
  
    return (
        <div>
            <Editor
                value={value}
                onValueChange={(e) => {
                    handleValueChange(e)
                    if (props.onChange) props.onChange(e);
                  }
                }
                highlight={(code) => highlight(code)}
                padding={10}
                style={{
                  boxShadow: '0px 0px 10px 1px #e0e0e0',
                  fontFamily: 'monospace',
                  fontSize: 16,
                  border: '2px solid  #0c5c75',
                  borderRadius: '10px',
                  minHeight: '40px'
                }}
                onKeyDown={handleKeyDown}
                name={name}
                onFocus={handleOnFocus}
                onBlur={() => setSuggestions([])}
            />
            {/* Dropdown de sugestões */}
            {suggestions.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  width:'350px',
                  background: '#fff',
                  border: '1px solid  #0c5c75',
                  zIndex: 999
                }}
              >
                {props.suggestionTitle && <h4 style={{padding: '4px'}}>{props.suggestionTitle}</h4>}
                {suggestions.map((s, index) => (
                  <div
                    key={index}
                    style={{ padding: '4px 8px', cursor: 'pointer' }}
                    onMouseDown={(e) => {
                      // onMouseDown para evitar perder o foco antes de clicar
                      e.preventDefault();
                      // Substitui o último token pela sugestão clicada
                      const tokens = value.split(/\s+/);
                      console.log("onMouseDown", tokens)
                      tokens[tokens.length - 1] = s;
                      setValue(tokens.join(' '));
                      if (props.onChange) props.onChange(tokens.join(' '));
                      setSuggestions([]);
                    }}
                  >
                    {s}
                  </div>
                ))}
              </div>
            )}
      </div>
    );
}